<template>
    <div class="dm-single-editor-card mb-4">
        <label
            :for="'select-agent-option-' + editor.id"
            class="card card-custom gutter-b radio p-4"
            :class="{ 'border-success': submission.editor_id == editor.id }"
            @click="selectAgentIfOpenForSubmissions()"
        >
            <div
                class="d-flex align-items-center dm-editor-card-content"
            >
                <div class="d-flex w-100 dm-editor-card-image-wrap">
                    <div class="dm-editor-card-image">
                        <img :src="editor.profile_image_url" />
                    </div>
                    <div class="dm-editor-card-name-status">
                        <h3>{{ editor.name }}</h3>
                        <span
                            class="label label-light-danger label-inline mt-2 mb-3"
                            v-if="!editor.open_for_submissions"
                            >Currently not taking submissions</span
                        >
                    </div>
                </div>

                <div class="w-100 dm-editor-card-pitch">
                    <p>{{ editor.personal_pitch }}</p>
                    <p class="mb-0 text-right">
                        <a
                            class="btn btn-link btn-light-success font-weight-bold mb-0"
                            v-if="editor.custom_presentation_link"
                            target="_blank"
                            :href="editor.custom_presentation_link"
                            >View Profile</a
                        >

                        <ViewProfileButtonandModal v-else :editor="editor" />
                    </p>
                </div>
            </div>
        </label>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";
import ViewProfileButtonandModal from "./ViewProfileButtonandModal.vue";

export default {
    components: { ViewProfileButtonandModal },

    props: ["editor"],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),

        selectAgentIfOpenForSubmissions() {
            if (!this.editor.open_for_submissions) return;

            this.submission.editor_id = this.editor.id;
            this.saveSubmission();
        },
    },
};
</script>
